import axios from 'axios';

// Get backend URL from env
const API_BASE = process.env.REACT_APP_BACKEND_URL || '';
const API = `${API_BASE}/api`;

// Configure axios to prevent caching
axios.defaults.headers.common['Cache-Control'] = 'no-cache, no-store, must-revalidate';
axios.defaults.headers.common['Pragma'] = 'no-cache';
axios.defaults.headers.common['Expires'] = '0';

// Use localStorage so session ends when browser closes
const getToken = () => localStorage.getItem('token');

export const setToken = (token) => {
  localStorage.setItem('token', token);
  axios.defaults.headers.common['Authorization'] = `Bearer ${token}`;
};

export const clearToken = () => {
  localStorage.removeItem('token');
  localStorage.removeItem('user');
  delete axios.defaults.headers.common['Authorization'];
};

export const authApi = {
  register: async (data) => {
    const response = await axios.post(`${API}/auth/register`, data);
    return response.data;
  },
  
  login: async (data) => {
    const response = await axios.post(`${API}/auth/login`, data);
    if (response.data.access_token) {
      setToken(response.data.access_token);
      // Store user data in localStorage for role-based access
      if (response.data.user) {
        localStorage.setItem('user', JSON.stringify(response.data.user));
      }
    }
    return response.data;
  },
  
  getMe: async () => {
    const token = getToken();
    if (!token) throw new Error('No token');
    
    const response = await axios.get(`${API}/auth/me`, {
      headers: { Authorization: `Bearer ${token}` }
    });
    return response.data;
  },
  
  logout: () => {
    clearToken();
  }
};

// Initialize token if exists
const token = getToken();
if (token) {
  setToken(token);
}